import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { useBehavioralTrackingProps } from '../../core/hooks/useBehavioralTrackingProps.js';
import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import { mergeProps } from '../../core/utils/merge-props.js';
import { type MenuIntentProps } from '../../navigation/menu/Intent.js';
import { Menu } from '../../navigation/menu/Menu.js';

/**
 * Accepted properties for the IntentButton.OpenWith.
 * @public
 */
export type OpenWithProps = Omit<
  MenuIntentProps,
  'onResponse' | 'options' | 'children'
> &
  BehaviorTrackingProps;

/**
 * The `OpenWith` component renders an `IntentMenu` with a default label
 * that can't be changed.
 * @public
 */
export const OpenWith = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  OpenWithProps
>(({ ...allProps }, forwardedRef) => {
  const [behavioralTrackingProps, restProps] =
    useBehavioralTrackingProps(allProps);
  return (
    <Menu.Intent
      {...mergeProps(restProps, behavioralTrackingProps)}
      options={{ keyProperties: [] }}
      ref={forwardedRef}
    >
      <FormattedMessage
        id="F6H1FQ86mt53ZgVL"
        defaultMessage="Open with..."
        description="Default label for the intent button component."
      />
    </Menu.Intent>
  );
});

(OpenWith as typeof OpenWith & { displayName: string }).displayName =
  'IntentButton.OpenWith';
